import React, {useState} from 'react';
import {useGet} from "../../network/useGet";
import {Button} from "primereact/button";
import NetworkWrapper from "../NetworkWrapper";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {deleteFromHub, postToHub} from "../../network/actions";
import {ConfirmDialog} from "primereact/confirmdialog";
import {useNotificationContext} from "../../context/NotificationContext";

function ThermalScans(props) {
    const { toast } = useNotificationContext();
    const [reloadCount, setReloadCount] = useState(0);
    const [selectedPassenger, setSelectedPassenger] = useState(null);
    const [confirmationAccountId, setConfirmationAccountId] = useState(false);
    const [hardRefresh, setHardRefresh] = useState(false);
    const { isLoading, data, error } = useGet("thermal/scan?refreshCache=" + hardRefresh, reloadCount);


    const addTest = async (accountId, pass, addFailConfirmed = false) => {
        if(pass || addFailConfirmed) {
            setSelectedPassenger(null);

            const response = await postToHub("thermal/scan/addScan", {accountId,pass});
            if(response === "") {
                toast.current.show({severity: 'success', summary: 'Test result added'});
                triggerDataUpdate();
            }
            else {
                toast.current.show({severity: 'error', summary: 'Error', detail: 'There has been an error. Please contact support'});
            }
        }
        else {
            setConfirmationAccountId(accountId);
        }
    }

    const triggerDataUpdate = () => {
        if(hardRefresh) {
            setHardRefresh(false);
        }
        else {
            setReloadCount(reloadCount + 1);
        }
    }

    const hideDialog = () => {
        setConfirmationAccountId(false);
    }

    return (
        <NetworkWrapper isLoading={isLoading} error={error}>
            {data &&
            <div className="max-w-full">
                <div className="flex">
                    <Button
                        icon="pi pi-refresh"
                        label="Refresh"
                        onClick={() => hardRefresh ? setReloadCount(reloadCount + 1 ) : setHardRefresh(true)}
                    />
                </div>
                <div style={{display: "grid", gridTemplateColumns: "3fr minmax(250px, 1fr)"}}>
                    <DataTable
                        className="mt-4 p-datatable-striped text-sm lg:text-base"
                        value={data.passengers}
                        removableSort
                        columnResizeMode="expand"
                        onRowClick={(row) => setSelectedPassenger({accountNumber: row.data.accountNumber, name: row.data.name})}
                        filterDisplay="row">
                        <Column field="name"
                                header="Name"
                                sortable={true}
                                filter={true}
                                filterMatchMode="contains"/>

                        <Column field="cabinNumber"
                                header="Cabin"
                                style={{width:'15%'}}
                                sortable={true}
                                filter={true}/>

                        <Column field="scanSlot.status"
                                header="Status"
                                style={{width:'15%', textAlign: "center"}}
                                sortable={true}
                                body={(rowData) => formatStatus(rowData.scanSlot?.status)}/>

                        <Column field="status"
                                header="Add PASS"
                                style={{width:'15%', textAlign: "center"}}
                                body={(rowData) => addScanButton(rowData, true, addTest)}/>

                        <Column field="status"
                                header="Add FAIL"
                                style={{width:'15%', textAlign: "center"}}
                                body={(rowData) => addScanButton(rowData, false, addTest)}/>

                    </DataTable>
                    <div className="ml-4">
                        {selectedPassenger &&
                        <ThermalDetails
                            passenger={selectedPassenger}
                            onClose={() => setSelectedPassenger(null)}
                            addTest={addTest}
                            triggerDataUpdate={triggerDataUpdate}
                        />
                        }
                    </div>
                </div>
                <ConfirmDialog
                    visible={!!confirmationAccountId}
                    header="Confirmation"
                    message={`You are about to add a failed test. Are you sure?`}
                    accept={() => {
                        addTest(confirmationAccountId, false, true)
                        hideDialog();
                    }}
                    reject={hideDialog}
                />
            </div>
            }
        </NetworkWrapper>

    );
}

function ThermalDetails(props) {
    const { toast } = useNotificationContext();
    const [reloadCount, setReloadCount] = useState(0);
    const [deleteId, setDeleteId] = useState(false);
    const { isLoading, data, error } = useGet(`thermal/scan/getScans?accountNumber=${props.passenger.accountNumber}`, reloadCount);

    const deleteTest = async (scanId) => {
        const response = await deleteFromHub(`thermal/scan/removeScan?scanId=${scanId}`);

        // TODO get a better condition for response successful or not
        if(response === "") {
            toast.current.show({severity: 'success', summary: 'Test result deleted'});
            setReloadCount( reloadCount + 1);
            props.triggerDataUpdate();
        }
        else {
            toast.current.show({severity: 'error', summary: 'Error', detail: 'There has been an error. Please contact support'});
        }
    }


    const hideDialog = () => {
        setDeleteId(false);
    }

    const currentDate = new Date().toISOString().split('T')[0];


    return (
        <NetworkWrapper isLoading={isLoading} error={error}>
            {data && data.scanSlots &&
            <div>
                <p className="font-bold text-lg">
                    {props.passenger.name}
                </p>
                <div className="flex justify-between">
                    <Button
                        label="Add PASS"
                        onClick={() => {props.addTest(props.passenger.accountNumber, true);}}
                    />
                    <Button
                        label="Add FAIL"
                        onClick={() => {props.addTest(props.passenger.accountNumber, false);}}
                    />
                </div>

                {data.scanSlots.map((scanSlot, slotIndex) =>
                <div className="mt-4" key={scanSlot.slotId}>
                    <p className="font-bold">
                        {scanSlot.slotDate}
                    </p>
                    <div>
                        {scanSlot.scans.map((scan, scanIndex) =>
                            <div className="mb-2 relative" key={scan.scanId}>
                                <p>Timestamp: {formatTime(scan.scanTime)}</p>
                                <p>Result: {scan.scanResult}</p>
                                {scanSlot.slotDate === currentDate && scanIndex === 0 &&
                                <div className="absolute right-0 top-0">
                                    <Button
                                        icon="pi pi-times"
                                        onClick={() => {setDeleteId(scan.scanId)}}
                                        severity='danger'
                                        rounded
                                        text
                                    />
                                </div>
                                }
                            </div>
                        )}
                    </div>
                </div>)}
                <div className="mt-6">
                    <Button label="Close" onClick={props.onClose}/>
                </div>
                <ConfirmDialog
                    visible={!!deleteId}
                    header="Confirmation"
                    message={`You are about to delete a test. Are you sure?`}
                    accept={() => {
                        deleteTest(deleteId);
                        hideDialog();
                    }}
                    reject={hideDialog}
                />
            </div>
            }
        </NetworkWrapper>
    )
}

function formatTime(timestamp) {
    const date = new Date(timestamp);
    return date.toLocaleTimeString();
}

function addScanButton(rowData, scan, addTest) {
    if(rowData.scanSlot?.status !== "Amber") {
        return null;
    }

    return (
        <Button
            label={scan ? "Add PASS" : "Add FAIL"}
            onClick={(e) => {e.stopPropagation(); addTest(rowData.accountNumber, scan);}}
        />
    )
}



function formatStatus(status) {
    const bgColorClass = getColorClass(status);
    return <span className={`inline-block w-6 h-6 rounded-full align-middle ${bgColorClass}`}></span>;
}

function getColorClass(status) {
    switch (status) {
        case "Green":
            return "bg-green-400";
        case "Red":
            return "bg-red-400";
        case "Amber":
            return "bg-yellow-400";
        default:
            return "bg-gray-400";
    }
}


export default ThermalScans;